import { render } from "./ThongTinXe.vue?vue&type=template&id=5592bc13&scoped=true"
import script from "./ThongTinXe.vue?vue&type=script&lang=js"
export * from "./ThongTinXe.vue?vue&type=script&lang=js"

import "./ThongTinXe.vue?vue&type=style&index=0&id=5592bc13&lang=scss&scoped=true"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5592bc13"]])

export default __exports__